import { render, staticRenderFns } from "./QueueItem.vue?vue&type=template&id=45902b8d"
import script from "./QueueItem.vue?vue&type=script&lang=js"
export * from "./QueueItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports